import { firebase, firestore } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import { errorOfType } from '../utilities/Errors'

const addBuyClick = async ({ buyClick }) => {
	const entry = {
		...buyClick,
		createdTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
		modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
		appUrl: global.document.location.href
	}
	try {
		if (entry.uid && entry.itemKey && entry.url) {
			await firestore.collection('buyClicks').add(entry)
			return { success: true, buyClick }
		}
		return { success: false, buyClick }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, buyClick, exception)
	}
}

export default addBuyClick



// WEBPACK FOOTER //
// ./src/dataservices/addBuyClick.js